var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'box-viewmore',
    {
      open: _vm.open
    }
  ]},[(_vm.title)?_c('div',{staticClass:"title-box v-line"},[_c('h2',[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('div',{ref:_vm.refName,class:!_vm.isHidden ? 'box-content-hidden' : 'box-content'},[_vm._t("default",null,{"id":"content"})],2),_c('div',{staticClass:"flex justify-center"},[(_vm.isHidden)?_c('button',{staticClass:"btn-viewmore mr-0",on:{"click":function($event){return _vm.openView()}}},[_c('span',[_vm._v(_vm._s(_vm.getExpandLabel))]),_c('i',{staticClass:"icon icon-bor-triangle-down text-primary",class:{ rotate: this.open }})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }